import { makeUnitPaymentMethodsRepository } from 'modules/customer/infra/repositories';

import { FetchUnitPaymentMethodsUseCase } from './implementations/FetchUnitPaymentMethodsUseCase';

let instance: FetchUnitPaymentMethodsUseCase | null = null;

export default function makeFetchUnitPaymentMethodsUseCase() {
  if (!instance) {
    const repository = makeUnitPaymentMethodsRepository();

    instance = new FetchUnitPaymentMethodsUseCase(repository);
  }

  return instance;
}
